import type { SortModel } from '@thinkalpha/table-client';

export const OptimizedTableSortKey = 'tableSort';
export type OptimizedTableSortEntry = { [OptimizedTableSortKey]: SortModel };
export const OptimizedTableFilterKey = 'tableFilter';
export type OptimizedTableFilter = { filter: string; type: 'raw-formula' | 'formula' | 'search' };
export type OptimizedTableFilterEntry = {
    [OptimizedTableFilterKey]: OptimizedTableFilter | undefined;
};

export function makeOptimizedTableSortKey(sort: SortModel = {}): OptimizedTableSortEntry {
    return { [OptimizedTableSortKey]: sort };
}
export function isOptimizedTableSortKey(obj: any): obj is OptimizedTableSortEntry {
    return obj && typeof obj === 'object' && OptimizedTableSortKey in obj;
}

export function makeOptimizedTableFilterKey(
    filter: string | undefined,
    type: 'raw-formula' | 'formula' | 'search',
): OptimizedTableFilterEntry {
    return { [OptimizedTableFilterKey]: filter ? { filter, type } : undefined };
}
export function isOptimizedTableFilterKey(obj: any): obj is OptimizedTableFilterEntry {
    return obj && typeof obj === 'object' && OptimizedTableFilterKey in obj;
}

export function isSpecialTableQueryKey(obj: any): obj is OptimizedTableSortEntry | OptimizedTableFilterEntry {
    return isOptimizedTableSortKey(obj) || isOptimizedTableFilterKey(obj);
}

export function getSpecialTableQueryKeys(queryKey: readonly unknown[]): {
    sort: SortModel | undefined;
    filter: OptimizedTableFilter | undefined;
    rest: readonly unknown[];
} {
    let sort: SortModel | undefined;
    let filter: OptimizedTableFilter | undefined;
    const rest: unknown[] = [];

    for (const keyPart of queryKey) {
        if (isOptimizedTableSortKey(keyPart)) {
            sort = keyPart[OptimizedTableSortKey];
        } else if (isOptimizedTableFilterKey(keyPart)) {
            filter = keyPart[OptimizedTableFilterKey];
        } else {
            rest.push(keyPart);
        }
    }

    return { sort, filter, rest };
}
